export default __webpack_public_path__ + "static/media/secondaryspinner.e2960442.gif";